import Ws from '@adonisjs/websocket-client';

export class SocketConnection {
  /**
   *
   * @returns {SocketConnection}
   */
  connect() {
    this.ws = Ws(process.env.VUE_APP_WS_BASE_API)
      .connect();

    this.ws.on('open', () => {
      console.log('Connection initialized');
    });

    this.ws.on('close', () => {
      console.log('Connection closed');
    });

    return this;
  }

  /**
   *
   * @param channel
   * @param handler
   * @returns {*}
   */
  subscribe(channel, handler) {
    if (!this.ws) {
      setTimeout(() => this.subscribe(channel), 1000);
      return;
    }

    const result = this.ws.subscribe(channel);

    result.on('percentage', (percentage) => {
      console.log('Incoming', percentage);
      handler(percentage);
    });

    result.on('close', (close) => {
      console.error(close);
    });

    result.on('error', (error) => {
      channel.close();
      console.error(error);
    });

    return result;
  }
}

export default new SocketConnection();
